import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.6_@types+node@26.0.0_cac@6.7.14_db0@0.3.4_eslint@9.39.4_jiti@_litq45cmvj5p2y2c5663veeyyq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.6_@types+node@26.0.0_cac@6.7.14_db0@0.3.4_eslint@9.39.4_jiti@_litq45cmvj5p2y2c5663veeyyq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts")
}